import { Component, OnDestroy, type OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { LoggerService } from 'src/app/services/logger.service';
import { IOnlineHelp } from './online-help.constants';
import { OnlineHelpService } from './online-help.service';

@Component({
  selector: 'app-online-help',
  templateUrl: './online-help.component.html',
  styleUrl: './online-help.component.scss',
})
export class OnlineHelpComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor(
    private readonly _policyService: PolicyService,
    private readonly _helpService: OnlineHelpService,
    private readonly _router: Router
  ) {}

  ngOnInit(): void {
    this.watchRouter();
  }

  toggleOnlineHelpSidenav(): void {
    this._helpService.toggle();
  }

  watchRouter() {
    combineLatest({
      navigationEvent: this._router.events,
      policyLoaded: this._policyService.detailLoadedObs,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ navigationEvent, policyLoaded }: {[key: string]: any}) => {
        if (policyLoaded && navigationEvent.routerEvent instanceof NavigationEnd) {
          LoggerService.logInfo(this.constructor.name, 'watchRouter', {
            event: navigationEvent.routerEvent.urlAfterRedirects,
          });
          this._helpService.refreshMap(navigationEvent.routerEvent.urlAfterRedirects);
        }
      });
  }

  get opened(): boolean {
    return this._helpService.opened;
  }

  get selectedMap(): IOnlineHelp {
    return this._helpService.selectedMap;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
